/**
 * 订单接口相关数据
 */

import {combineReducers} from 'redux';
import allOrders from './allOrders';
import tripOrder from './tripOrder';

export default combineReducers({
  allOrders,
  tripOrder
});



// WEBPACK FOOTER //
// ./src/store/reducers/order/index.js